import { ConfigurationSectionAssayGroupResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section-assay-group/configuration-section-assay-group.dto'
import { store } from '@/store/store'

export interface ConfigurationLocalAssaysSectionsModalAssaysGroupsFormState {
    sectionAssaysGroups: ConfigurationSectionAssayGroupResponse[]
    laboratoryId: number
}
export const initialConfigurationLocalAssaysSectionsModalAssaysGroupsFormState =
    (): ConfigurationLocalAssaysSectionsModalAssaysGroupsFormState => ({
        sectionAssaysGroups: [],
        laboratoryId: store.getters.labId
    })
